import React from 'react';
import { ModuleBridge } from '../components';

export const ReportingBackupPolicies = () => {
    return <ModuleBridge moduleId="reporting_backup_policies_module" />;
};
